import { render, staticRenderFns } from "./CommunityForm.vue?vue&type=template&id=4dd5e25e&"
import script from "./CommunityForm.vue?vue&type=script&lang=js&"
export * from "./CommunityForm.vue?vue&type=script&lang=js&"
import style0 from "./CommunityForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports